module.exports = __webpack_public_path__ + "static/img/banner1@3x.300bcce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/banner1@3x.png
// module id = nBhg
// module chunks = 1